import { render, staticRenderFns } from "./VsTabs.vue?vue&type=template&id=ff5042e2&scoped=true&lang=html"
import script from "./VsTabs.vue?vue&type=script&lang=js"
export * from "./VsTabs.vue?vue&type=script&lang=js"
import style0 from "./VsTabs.vue?vue&type=style&index=0&id=ff5042e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5042e2",
  null
  
)

export default component.exports